import { Component, OnInit, inject } from '@angular/core';
import { APIService } from 'app/services/api.service';
import { AuthenticationService } from 'app/services/auth.service';
import { LoaderService } from "app/services/loader.service";
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from "app/app.config";
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { CYRChartComponent } from '../../components/NWMCharts/cyrchart.component';
import { DecimalPipe, DatePipe } from '@angular/common';
import { MinusSignToParens } from 'app/pipes/minus-sign-to-parens.pipe';
import { PlaceholderPipe } from 'app/pipes/placeholder.pipe';

type apiTableInformationType = {
  InceptionActivity: number;
  InceptionReturn: string;
  MarketValue: number;
  ValuationDate: string;
  YtdActivity: number;
  YtdReturn: string;
};

type apiDataType = {
  TableInformation: apiTableInformationType[];
};

@Component({
    templateUrl: './CYR-details.component.html',
    styleUrls: ['./CYR-details.component.scss'],
    imports: [MenuComponent, CYRChartComponent, DecimalPipe, DatePipe, MinusSignToParens, PlaceholderPipe]
})

export class CYR_DetailsComponent implements OnInit {
  private api = inject(APIService);
  private auth = inject(AuthenticationService);
  private loaderService = inject(LoaderService);
  private route = inject(ActivatedRoute);
  private config = inject(AppConfig);

  public plan?: string;
  public data: apiTableInformationType[] = [];
  public valuationDate = '';
  public isPershing = false;

  ngOnInit() {
    this.loaderService.display(true, 'CYR-details');

    const reRg = this.auth.getCurrentReRg()!;

    this.isPershing = reRg.IsPershing;

    this.route.params.subscribe(params => this.plan = params['id'] ? params['id'] : '');

    this.valuationDate = this.auth.getCurrentValuationDate();

    const planPath = this.api.getPlanPath(this.plan || '', reRg.IsPershing);
    this.api.get<apiDataType>(`${this.config.portfolio.portfolioDetailsCalendarYearReturnsUrl}/${reRg.ReRgId}/${this.valuationDate}/${planPath}`).subscribe(
      data => {
        this.data = data.TableInformation;
        this.loaderService.display(false, 'CYR-details');
      },
      () => this.loaderService.display(false, 'CYR-details')
    );
  }

}